var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitationResend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.523,
    height: 13,
    viewBox: "0 0 14.523 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mail",
    d: "M14.52,28.989V36.67a1.6,1.6,0,0,1-1.6,1.6H1.6A1.6,1.6,0,0,1,0,36.67V28.717a1.6,1.6,0,0,1,1.6-1.6h6.42a.271.271,0,1,1,0,.542H1.6A1.055,1.055,0,0,0,.542,28.717v.8l6.205,3.014a1.169,1.169,0,0,0,1.025,0l4.13-2a.271.271,0,0,1,.236.488l-4.13,2a1.708,1.708,0,0,1-1.5,0l-5.968-2.9V36.67A1.055,1.055,0,0,0,1.6,37.724H12.923a1.055,1.055,0,0,0,1.054-1.054V28.989a.271.271,0,1,1,.542,0ZM4.237,33.647,1.593,36.29a.271.271,0,0,0,.384.384L4.62,34.03a.271.271,0,0,0-.384-.384Zm5.663,0a.271.271,0,0,0,0,.384l2.643,2.643a.271.271,0,0,0,.384-.384l-2.643-2.643a.271.271,0,0,0-.384,0Zm-.418-3.588c.7-.784.9-1.078,1.458-1.33a.271.271,0,0,0-.222-.495,3.175,3.175,0,0,0-1.167.932,2.353,2.353,0,0,1,2.351-2.33.271.271,0,0,0,.271-.271V26.1l1.644,1.306-1.644,1.306v-.463a.271.271,0,0,0-.542,0v1.025a.271.271,0,0,0,.44.212l2.351-1.868a.271.271,0,0,0,0-.425L12.07,25.326a.271.271,0,0,0-.44.212V26.3a2.9,2.9,0,0,0-2.622,2.881v.693a.272.272,0,0,0,.474.18Z",
    transform: "translate(0 -25.267)",
    fill: "#adb4b9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationResend);
export default __webpack_public_path__ + "static/media/invitation-resend.d62c57e9.svg";
export { ForwardRef as ReactComponent };